import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../shared/api-response.model';
import {ApiVisa} from '../shared/api-visa.model';
import { PgwLabelLinkContainerModel } from '../../../../../models';
import { PgwLabelLinkCriteriaModelQuery, PgwLabelLinkQueryCriteriaClass } from '../../criteria/pgw/pgw-label-link-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class PgwLabelLinkService extends BaseApiTemplateService<PgwLabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-links';
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: PgwLabelLinkQueryCriteriaClass
  ): Promise<ApiResponseModel<PgwLabelLinkContainerModel>> {
    const buildDocCriteria = new PgwLabelLinkCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<ApiResponseModel<PgwLabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getPromiseByCriteriaBasic(
    visa: ApiVisa, criteria?: PgwLabelLinkQueryCriteriaClass
  ): Promise<BasicApiResponseModel<PgwLabelLinkContainerModel>> {
    const buildDocCriteria = new PgwLabelLinkCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<BasicApiResponseModel<PgwLabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }
}
